export default "__VITE_ASSET__DsDkb6Kt__"